import { Component, Input, OnInit } from '@angular/core';
import { concatMap, finalize, map, mergeAll, tap } from 'rxjs/operators';

import {
  DocumentStatus,
  DownloadAllPrivateNumberBuyRequestDocumentsDto,
  PrivateNumberPurchaseDocuments,
  UpdatePrivateNumberBuyDocumentsStatusCommand,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { PrivateNumberBuyRequestService } from '../../../core/api/services/private-number-buy-request.service';

@Component({
    selector: 'app-private-number-documentation',
    templateUrl: './private-number-documentation.component.html',
    styleUrls: ['./private-number-documentation.component.scss'],
    standalone: false
})
export class PrivateNumberDocumentationComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  @Input() requestId;
  @Input() childOrganizationId;
  @Input() documentationTypes;

  authenticateModel: UpdatePrivateNumberBuyDocumentsStatusCommand = {};
  blobs: any[] = [];
  documentLoading: boolean = false;

  model: UpdatePrivateNumberBuyDocumentsStatusCommand[] = [];
  get DocumentStatus() {
    return DocumentStatus;
  }

  //#endregion

  constructor(protected currentService: PrivateNumberBuyRequestService) {
    super();
    this.formPageConfig.vocabs =
      'pages.privateNumberBuyRequests.privateNumberDocuments.form.';
  }

  //#region init methods

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showRefreshBtn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  initForm() {}

  initModel() {
    this.downloadDocumentsApi();
  }

  //#endregion

  //#region api

  //get all documents model
  downloadDocumentsApi() {
    this.unSubs();
    this.documentLoading = true;
    this.currentService
      .privateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments({
        OrganizationId: this.childOrganizationId,
        PrivateNumberBuyRequestId: this.requestId,
      })
      .pipe(
        map((res) => res.data),
        tap((items) => {
          this.createDocumentationInfoModel(items);
        }),
        mergeAll(),
        concatMap((item) => {
          return this.currentService
            .privateNumberBuyRequestPrivateNumberBuyRequestDocumentLink({
              Input: item.image,
            })
            .pipe(
              map((blob) => ({
                documentType: item.privateNumberPurchaseDocument,
                blob: blob,
              }))
            );
        }),
        finalize(() => (this.documentLoading = false))
      )
      .subscribe((res) => {
        this.blobs.push(res);
      });
  }

  //تغییر وضعیت تکی
  updateDocumentStatusApi(item) {
    this.currentService
      .privateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus({
        body: item,
      })
      .pipe(this.basePipeOperators())
      .subscribe(
        (result) => {
          this.apiNotificationService.notifyMessage({ result });
          if (result.isSucceed) {
            this.formPageConfig.isEditMode = false;
            this.unSubs();
          }
        },
        (error) => ConsoleService.error('error', error),
        () => (this.loading = false)
      );
  }

  //#endregion

  //#region documentation operations

  //get blob file current item
  getBlob(documentType: number): Blob {
    try {
      const blob = this.blobs.find((blob) => {
        return blob.documentType == documentType;
      });

      if (blob) {
        return blob.blob;
      } else return null;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  //get all documents model
  createDocumentationInfoModel(items) {
    try {
      const values = Object.values(PrivateNumberPurchaseDocuments);
      let document: any[] = values.slice(values.length / 2);

      //creates an array of Model with enum length
      document.forEach((x) => {
        let findItem = items.find((b) => b.privateNumberPurchaseDocument == x);
        if (findItem) {
          this.model.push(findItem);
        } else {
          let model: DownloadAllPrivateNumberBuyRequestDocumentsDto = {};
          model.description = '';
          model.image = '';
          model.status = 1;
          model.privateNumberPurchaseDocument = x;
          this.model.push(model);
        }
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }
  //#endregion

  // تغییر وضعیت مدارک به صورت تکی
  changeStatus(item) {
    try {
      let modelItem: UpdatePrivateNumberBuyDocumentsStatusCommand = {};
      modelItem = item;
      modelItem.organizationId = this.currentUserInfo?.organizationId;
      modelItem.privateNumberBuyRequestId = this.requestId;

      this.updateDocumentStatusApi(modelItem);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  onReset() {
    this.model = [];
    this.initModel();
  }
}
